<template>
  <div class="page">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>在线人数</span>
        <el-button type="text" @click="$router.push('/admin/dashboard')">返回仪表盘</el-button>
      </div>
      <p class="hint">近 5 分钟内有登录态请求的门户用户，或近 5 分钟在创作空间有使用 / 停留的用户（并集去重），不含管理员。</p>
      <el-table v-loading="loading" :data="list" border stripe>
        <el-table-column prop="userId" label="用户 ID" width="110" />
        <el-table-column prop="nickname" label="昵称" min-width="140">
          <template slot-scope="{ row }">{{ row.nickname || '-' }}</template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="140">
          <template slot-scope="{ row }">{{ row.phone || '-' }}</template>
        </el-table-column>
        <el-table-column label="会员" width="140">
          <template slot-scope="{ row }">{{ membershipLevelLabel(row.membershipTier) }}</template>
        </el-table-column>
        <el-table-column label="活跃来源" width="140">
          <template slot-scope="{ row }">
            <el-tag :type="sourceTagType(row.source)" size="mini">{{ row.source || '门户' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="最近活跃" width="180">
          <template slot-scope="{ row }">{{ formatTime(row.lastSeenAt) }}</template>
        </el-table-column>
      </el-table>
      <div class="pager-wrap">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page="page"
          @current-change="onPageChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getOpsOnline } from '@/api/admin'
import { membershipLevelLabel } from '@/utils/adminConstants'
import { formatDateTime } from './opsFormat'

export default {
  name: 'OpsOnline',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      page: 1,
      pageSize: 20
    }
  },
  created() {
    this.load()
  },
  methods: {
    membershipLevelLabel,
    formatTime: formatDateTime,
    sourceTagType(source) {
      if (source === '创作空间') return 'warning'
      if (source === '门户+创作空间') return 'success'
      return 'info'
    },
    onPageChange(page) {
      this.page = page
      this.load()
    },
    async load() {
      this.loading = true
      try {
        const result = await getOpsOnline({ page: this.page, size: this.pageSize })
        this.list = (result && result.list) || []
        this.total = (result && result.total) || 0
      } catch (e) {
        this.list = []
        this.total = 0
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.hint {
  margin: 0 0 12px;
  color: #909399;
  font-size: 13px;
}
.pager-wrap {
  margin-top: 16px;
  text-align: right;
}
</style>
